import { useState, useRef } from "react";
import { FaChevronRight } from "react-icons/fa";
import CohortPillar from "./CohortPillar";
import useIsMobile from "../../hooks/useIsMobile";
import Pillar from "../Generic/Pillar";
import Cohort from "../Generic/Cohort";
import "../../styles/CohortButton.css";

const CohortButton = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const pillarsRef = useRef(null);
   const isMobile = useIsMobile();

  const scrollToPillars = () => {
    pillarsRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
    setActiveIndex(0);
  };

  const toggleCard = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const details = {
    pillars: {
      Mentorship:
        "Guided by industry leaders, WiSE provides mentorship in three formats to help women navigate challenges, gain clarity, and accelerate their growth in the semiconductor ecosystem.",
      "Events and Meetups":
        "WiSE hosts diverse online and offline events, including webinars, expert talks, and meetups, designed to foster learning, meaningful connections, and career growth within the semiconductor ecosystem.",
      Storytelling:
         "Through blogs, spotlights, and shared experiences, WiSE creates a platform for members and industry leaders to inspire, learn, and build confidence within the semiconductor community.",
      "Training and Projects":
        "WiSE offers skill-focused training and hands-on projects that bridge academia and industry, empowering women with practical experience and confidence for real-world success.",
    },
    cohort: {
      Crawl: {
        years: "-2 to +2 years",
        description:
          "For students and early learners, building core semiconductor knowledge, foundational concepts, and industry-ready skills.",
      },
      "Climb and Consolidate": {
        years: "+2 to 7 years",
        description:
          "For women in early industry years, strengthening technical depth and career direction.",
      },
      "Cultivate and Craft": {
        years: "7 to 15 years",
        description:
          "For women advancing into senior roles, focusing on leadership, decision-making, collaboration, and long-term growth.",
      },
      "Command and Contribute": {
        years: "15+ years",
        description:
          "For experienced women leaders, influencing industry growth through mentorship and leadership."
      },
      Comeback: {
        years: "Re-entry",
        description:
          "For women returning after a career break, supporting skill refresh, confidence rebuilding, and smooth industry re-entry.",
      },
    },
    programs: {
      "Career Entrench":
        "Offline meetups and learning sessions for early-career professionals.",
      "Career Advance": "Mentorship to accelerate career progression.",
      "Career Coach": "Hands-on projects and real-world exposure.",
      "Campus to Career": "Bridging academics and industry.",
      Reignite: "Programs supporting career re-entry.",
    },
  };

  return (
    <>
      {/* TOP SECTION (Gradient only till image) */}
      <section id="cohort-structure" className="cohort-hero text-white py-5">
        <div className="cohort-wrapper pt-0">
          <div className="cohort-header">
            <h1 className="wise-secondary-gradient cohort-heading">
              Cohort Structure
            </h1>
            <p className="cohort-subtitle">
              Empowering women through mentorship, innovation, and collaboration
              in the semiconductor industry.
            </p>
          </div>

          <CohortPillar onClick={scrollToPillars} />
        </div>

       {isMobile ? (
  //  MOBILE VIEW
  <div className="container">
    {/* Pillars Card */}
    <div
      ref={pillarsRef}
      className={`cohort-format-card hover-effect-only ${
        activeIndex === 0 ? "active" : ""
      }`}
      onClick={() => toggleCard(0)}
    >
      <div className="format-content">
        <h5 className="card-main-title">OUR PILLARS</h5>
        <p>
          A holistic foundation of mentorship, learning, storytelling, and
                hands-on growth—designed to empower women at every stage of
                their semiconductor journey.
        </p>

        {activeIndex === 0 && (
          <div className="mt-3">
            <CardContent items={details.pillars} />
          </div>
        )}
      </div>

      <FaChevronRight
        className={`mentor-arrow-icon ${
          activeIndex === 0 ? "rotate" : ""
        }`}
      />
    </div>

    {/* Cohorts Card */}
    <div
      className={`cohort-format-card hover-effect-only ${
        activeIndex === 1 ? "active" : ""
      }`}
      onClick={() => toggleCard(1)}
    >
      <div className="format-content">
        <h5 className="card-main-title">OUR COHORTS</h5>
        <p>
          Structured career-stage communities designed to support women
                from early learning to leadership and re-entry within the
                semiconductor ecosystem.
        </p>

        {activeIndex === 1 && (
          <div className="mt-3">
            <CardContent items={details.cohort} />
          </div>
        )}
      </div>

      <FaChevronRight
        className={`mentor-arrow-icon ${
          activeIndex === 1 ? "rotate" : ""
        }`}
      />
    </div>
  </div>
) : (
    <div className="container mt-5">
  
    <Pillar />
    <Cohort />
    </div>
 
)}
      </section>
    </>
  );
};
const CardContent = ({ items }) => (
  <div>
    {Object.entries(items).map(([title, data]) => {
      const isObject = typeof data === "object";

      return (
        <div key={title} className="mb-4">
          <h4 className="inner-section-title ">
            {title}
            {isObject && data.years && (
              <span className="inner-years"> ({data.years})</span>
            )}
          </h4>

          <p>{isObject ? data.description : data}</p>
        </div>
      );
    })}
  </div>
);


export default CohortButton;
